export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    try {
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result.replace("data:image/jpeg;base64,", ""));
      };
    } catch (err) {
      reject(err);
    }
  });
}
